var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-5"},[_c('b-card',{attrs:{"header-tag":"header"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',{staticClass:"d-flex flex-row align-items-center"},[_c('h3',{staticClass:"confirmation_step-header m-0 ml-3"},[_vm._v(_vm._s(_vm.stepTitle))])])]},proxy:true}])},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }